import React from 'react';
import DesignerCardImage from '../DesignerCardImage';

export default function InternalPromoteCard ({card_info}){
  let { headline, linking_slug, type, card_img_id, card_img_alt, card_title, position, cardNum, hover_text } = card_info;

  let link = `/${type}/${linking_slug}`;
  let imgId = card_img_id;
  let imgAlt = card_img_alt;

  let commonTrackingData = {
    'data-user-decision-area': 'featured designer section',
    'data-type': type
  }
  let trackingData = type == 'content'
                      ? {
                        'data-content-title': headline,
                        "data-selection": headline
                        }
                      : {
                        'data-product-type': 'Wedding Gowns',
                        "data-selection": card_title,
                        'data-position': position
                      };

  return (
      <a id={`internal-promote-card-${cardNum}`} href={link} {...commonTrackingData} {...trackingData} >
        <DesignerCardImage image={imgId} alt={imgAlt} />
        <div class="collection-name-container collection-name-container-text">
          <div class="collection-name byline" dataHoverText={hover_text}>
            <span>{card_title}</span>
          </div>
        </div>
      </a>
  )
}
